<template>
  <div>
    <div v-if="!formularioShow" class="container">
      <div class="row">
        <div class="col">
          <TitleSection>Aguarde!<br/>Em breve as inscrições estarão abertas.</TitleSection>
        </div>
      </div>
    </div>
    <div v-if="formularioShow">
      <div class="container">
        <div class="row">
          <div class="col">
            <TitleSection>1. Escolha uma Modalidade</TitleSection>
          </div>
        </div>
      </div>
      <ul v-if="modalidadesAberta">
        <li v-for="(modalidade, index) in modalidades" :key="index">
          <Modalidade
            :index="index + 1"
            :name="modalidade.name"
          >
            <div @click="queroEstaHandle(modalidade.tipo)" v-if="modalidade.tipo=='kids'">
              <Button big>Quero esta</Button>
            </div>
            <!-- <div v-if="modalidade.tipo=='kids'">
              <Button big gray>Vagas esgotadas</Button>
            </div> -->
            <div @click="queroEstaHandle(modalidade.tipo)" v-if="modalidade.tipo=='revezamento'">
              <Button big>Quero esta</Button>
            </div>
            <!-- <div v-if="modalidade.tipo=='revezamento'">
              <Button big gray>Vagas esgotadas</Button>
            </div> -->
            <div @click="queroEstaHandle(modalidade.tipo)" v-if="modalidade.tipo=='corrida'">
              <Button big>Quero esta</Button>
            </div>
            <!-- <div v-if="modalidade.tipo=='corrida'">
              <Button big gray>Vagas esgotadas</Button>
            </div> -->
            <div @click="queroEstaHandle(modalidade.tipo)" v-if="modalidade.tipo=='caminhada'">
              <Button big>Quero esta</Button>
            </div>
            <!-- <div v-if="modalidade.tipo=='caminhada'">
              <Button big gray>Vagas esgotadas</Button>
            </div> -->
          </Modalidade>
        </li>
      </ul>
      <div class="mostrarModabilidades" v-if="!modalidadesAberta">
        <button @click="exibirModalidadesHandle()">Exibir Modalidades</button>
      </div>
      <div v-if="!modalidadesAberta">
        <Container gray>
          <TitleSection marginOff>2. Preencha o Formulário</TitleSection>
          <div v-if="formulariosAbertos.corrida">
            <LightText>
              <strong>Modalidade</strong>: CORRIDA Individual 5km
            </LightText>
            <CorridaInscrevase/>
          </div>
          <div v-if="formulariosAbertos.caminhada">
            <LightText>
              <strong>Modalidade</strong>: CAMINHADA Individual 5km
            </LightText>
            <CaminhadaInscrevase/>
          </div>
          <div v-if="formulariosAbertos.revezamento">
            <LightText>
              <strong>Modalidade</strong>: REVEZAMENTO 5km<br/>
              O preenchimento para inscrição do Revezamento deverá ser realizado por uma das pessoas da equipe. Tenha em mãos os dados de sua dupla e complete o formulário.
            </LightText>
            <RevezamentoInscrevase/>
          </div>
          <div v-if="formulariosAbertos.kids">
            <LightText>
              <strong>Modalidade</strong>: CAMINHADA KIDS 1km<br />
              As inscrições para Caminhada Kids são permitidas apenas para os dependentes cadastrados no SAP, até 11 anos e 12 meses de idade.
            </LightText>
            <KidsInscrevase/>
          </div>
        </Container>
      </div>
    </div>
  </div>
</template>

<script>
import Container from '@/components/Container'
import CorridaInscrevase from '@/wrappers/CorridaInscrevase'
import CaminhadaInscrevase from '@/wrappers/CaminhadaInscrevase'
import RevezamentoInscrevase from '@/wrappers/RevezamentoInscrevase'
import KidsInscrevase from '@/wrappers/KidsInscrevase'
import Button from '@/components/Button'
import TitleSection from '@/components/TitleSection'
import Modalidade from '@/components/Modalidade'
import LightText from '@/components/LightText'

export default {
  name: 'FormularioInscrevase',
  components: {
    TitleSection,
    Modalidade,
    Button,
    CorridaInscrevase,
    CaminhadaInscrevase,
    RevezamentoInscrevase,
    KidsInscrevase,
    Container,
    LightText,
  },
  methods: {
    exibirModalidadesHandle() {
      this.modalidadesAberta = true
    },
    queroEstaHandle(tipo) {
      this.formulariosAbertos = {
        corrida: false,
        caminhada: false,
        revezamento: false,
        kids: false,
      }
      this.modalidadesAberta = false
      this.formulariosAbertos[tipo] = true
    }
  },
  data: () => ({
    formularioShow: true,
    modalidadesAberta: true,
    formulariosAbertos: {
      corrida: false,
      caminhada: false,
      revezamento: false,
      kids: false,
    },
    modalidades: [
      {
        name: 'CORRIDA Individual  5Km',
        tipo: 'corrida'
      },
      {
        name: 'CAMINHADA Individual  2,5Km',
        tipo: 'caminhada'
      },
      {
        name: 'REVEZAMENTO DUPLO MISTO  5Km',
        tipo: 'revezamento'
      },
      {
        name: 'CAMINHADA KIDS 1Km',
        tipo: 'kids'
      },
    ]
  })
}
</script>

<style lang="scss" scoped>
.mostrarModabilidades {
  text-align: center;
  button {
    font-weight: 600;
    background: #C5C5C5;
    color: #fff;
    font-size: 15px;
    border-radius: 20px;
    border: 0;
    padding: 8px 21px;
    position: relative;
    top: 17px;
    cursor: pointer;
  }
}
</style>
